import { FormBuilderContext } from 'pages/Contexts/FormBuilderContext'
import * as React from 'react'
import Dropdown from 'ui/Dropdown'
import useBuilderQuestion from 'utils/FormBuilder/hooks/useBuilderQuestion'
import { hasText } from 'utils/helpers'

import { useLoadDemographicsIntegration } from '@/queries/integrations/demographics/useLoadDemographicsIntegration'

function BuilderSideMenuDemographicsOptions() {
  const { data: demographicsOptions } = useLoadDemographicsIntegration()
  const { selectedItem, setQuestion } = React.useContext(FormBuilderContext)

  const question = useBuilderQuestion(selectedItem.id)

  const options = React.useMemo(() => {
    return (
      demographicsOptions?.map((option) => {
        if (!option.type) {
          return option
        }

        const [optionType, optionSubtype] = option.type.split('#')
        const questionType = question?.question_type?.question_type || 'text'
        const questionSubtype =
          question?.question_type?.question_subtype || 'single_line'

        if (questionType === 'text' && questionSubtype === 'calculation') {
          return {
            ...option,
            disabled: !(
              optionType === 'number' ||
              ['single_line', 'multi_line'].includes(optionSubtype)
            ),
          }
        }

        // questionType [radio, checkbox] can be assigned to any text option or their own subtype
        if (questionType === 'radio' || questionType === 'checkbox') {
          return {
            ...option,
            disabled: !(
              ['text', 'number'].includes(optionType) ||
              (questionType === optionType && optionSubtype === questionSubtype)
            ),
          }
        }

        return {
          ...option,
          disabled: !(
            optionType === questionType && optionSubtype === questionSubtype
          ),
        }
      }) || []
    )
  }, [
    demographicsOptions,
    question?.question_type?.question_subtype,
    question?.question_type?.question_type,
  ])

  const onChange = React.useCallback(
    (demographics) => {
      setQuestion(selectedItem.id, {
        ...question,
        demographics: hasText(demographics) ? demographics : null,
      })
    },
    [question, selectedItem.id, setQuestion]
  )

  return (
    <div>
      <Dropdown
        label="Client Mapping"
        onChange={onChange}
        options={options}
        placeholder="Client Mapping"
        value={question?.demographics}
      />
    </div>
  )
}

export default BuilderSideMenuDemographicsOptions
